import Btn from './Btn'
import IconBtn from './IconBtn'

import { Box, Modal, Typography, useMediaQuery } from '@mui/material'
import { type ModalProps } from '@mui/material'
import { type MouseEventHandler } from 'react'
import { useTheme } from '@mui/material/styles'
import ErrorMessage from './ErrorMessage'
import { type TError } from '../redux/api/types'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

interface DlgProps extends ModalProps {
  name: string
  cancelBtnText?: string
  okBtnText?: string
  showBtn?: boolean
  handleClose: MouseEventHandler<HTMLButtonElement>
  handleSubmit?: MouseEventHandler<HTMLButtonElement>
  width?: number
  centredItems?: boolean
  bigOkBnt?: boolean
  okDisabled?: boolean
  disabled?: boolean
  errorMessage?: string
  isLoading?: boolean
  errorResponse?: TError
  isWarning?: boolean
}

const Dlg: React.FC<DlgProps> = (
  { name, cancelBtnText, showBtn = false, okBtnText, open, handleClose, handleSubmit, children, width = 592, centredItems, bigOkBnt, okDisabled = false, errorMessage, isLoading, errorResponse, disabled, isWarning = false }
) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '0px',
        borderRadius: isMobile ? 0 : 3,
        boxShadow: 0,
        py: 5,
        px: 5,
        width: isMobile ? '100%' : width,
        minHeight: isMobile ? '100%' : '300px',
        maxHeight: isMobile ? '100%' : '80vh',
        overflow: 'auto'
      }}
      >
        <form>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', pb: 1 }}>
        <Typography
          sx={{
            color: isWarning ? 'error.main' : 'rgba(107, 122, 153, 1)',
            display: 'flex',
            justifyContent: centredItems === true ? 'center' : 'flex-start',
            alignItems: 'center',
            width: '100%',
            fontSize: centredItems === true ? 20 : 16,
            fontWeight: 700
          }}>
            { isWarning
              ? <WarningAmberIcon sx={{
                height: '20px',
                mr: '4px'
              }}/>
              : null
            }
            {name}
          </Typography>
          <IconBtn icon='closeicon.svg' onClick={handleClose}/>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: (centredItems === true) ? 'center' : 'flex-start', alignItems: (centredItems === true) ? 'center' : 'stretch' }}>
          {children}
        </Box>
        { (cancelBtnText !== '' && okBtnText !== '') &&
          (
           <Box sx={{ display: 'flex', justifyContent: (centredItems === true) ? 'center' : 'flex-end', pt: '4px' }} >
            { (showBtn && cancelBtnText !== '') &&
              (
                <Btn variant= 'outlined' text={`${cancelBtnText ?? 'Close'}`} onClick={handleClose} />
              )
            }
            { okBtnText !== '' &&
              (
              <Btn variant= 'contained' color='secondary' text={`${okBtnText ?? 'Save Changes'}`}
                sx={{ width: (bigOkBnt === true) ? '346px' : 'auto', py: (bigOkBnt === true) ? '20px' : '8px', ml: (cancelBtnText === '') ? 0 : '15px' }}
                type='submit'
                disabled={disabled}
                onClick={handleSubmit}
              />
              )
            }
            </Box>
          )
        }
        </form>
        { errorMessage &&
          (<Box sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(230, 46, 46, 0.05)',
            p: 2,
            my: 3,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            fontSize: 14
          }}>
            <Typography sx={{ color: 'rgba(230, 46, 46, 1)', mx: 3 }}>
              {errorMessage}
            </Typography>
          </Box>) }
          { errorResponse && <ErrorMessage error={errorResponse}/> }
      </Box>
    </Modal>
  )
}

export default Dlg
